import { type ReactElement } from "react";
import { Helmet } from "react-helmet-async";

import { useGlobalMetadata } from "../../../hooks/useGlobalMetadata.ts";

// Renders site-wide <title> and <meta> defaults sourced from the canonical
// PageMetaData entry in Contentful. Pages that mount their own <Helmet>
// (e.g. StandardPageProviders) will override these per-tag, while routes
// without their own metadata block (synopsis, contact-us, 404, ...) inherit
// these defaults.
export function GlobalMetaHelmet(): ReactElement | null {
  const { metadata, loading } = useGlobalMetadata();

  if (loading) return null;

  const { title, description, image } = metadata;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
    </Helmet>
  );
}
